import axios from "axios";

import { API_BASE_URL } from "../constants";

export default class SoftwareAttachmentsService {
    static instance;

    static getInstance() {
        if (!SoftwareAttachmentsService.instance) {
            SoftwareAttachmentsService.instance = new SoftwareAttachmentsService();
        }

        return SoftwareAttachmentsService.instance;
    }

    async list(softwareId, filters) {
        const response = await axios.get(`${API_BASE_URL}/software/${softwareId}/documents`, {
            params: filters,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data || [];
    }

    async addAttachment(payload = {}){
        const response = await axios.post(`${API_BASE_URL}/asset_document/create_attachment`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                'Content-Type': 'multipart/form-data'
            }
        });
  
        return response.data.data;
    }

    async deleteAttachment(id){
        const response = await axios.delete(`${API_BASE_URL}/asset_document/${id}/delete_attachment`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
  
        return response.data.data;
    }
}
